const locale = {

    CANCEL: 'Отказ',
    SAVE: 'Запази',
    REQUIRED: 'е задължително',
	CREATE: 'Създай',
	UPDATE: 'Обнови',
	SAVING: 'Запазване...',
	DELETE: 'Изтрий',

    PROFILE: 'Профил',
    PROFILE_INFO: 'Следната информация се показва на вашият Екип!',
    NAME: 'Име',
    FIRST_NAME: 'Име',
    LAST_NAME: 'Фамилия',
    USERNAME: 'Потребителско име',
    ROLE: 'Роля',
    COMPANY: 'Компания',
    NOTES: 'Бележки',
    PERSONAL_INFO: 'Лична информация',
    CONTACT_DETAILS: 'Детайли за контакт в случай, че се нуждаем да се свържем с Вас.',
    EMAIL: 'Имейл',
    PHONE_NUMBER: 'Телефонен номер',
    COUNTRY: 'Държава',
    LANGUAGE: 'Език',
    SELECT_LANGUAGE: 'Изберете език',
    BULGARIAN: 'Български',
    ENGLISH: 'Английски',
	DESCRIPTION: 'Описание',


    ALERTS: 'Известия',
	COMMUNICATION: 'Комуникация',
	GET_NEWS_ANNOUNCEMENTS_PRODUCT_UPDATES: 'Получавайте новини, съобщения и актуализации за продукти.',
	SECURITY: 'Сигурност',
	IMPORTANT_NOTIFICATIONS_ACCOUNT_SECURITY: 'Получавайте важни известия за сигурността на акаунта ви.',
	MEETUPS: 'Срещи',
	EMAIL_WHEN_MEETUP_POSTED_NEAR: 'Получавайте имейл, когато е обявена среща близо до вашето местоположение.',
	ACCOUNT_ACTIVITY: 'Активност на акаунта',
	EMAIL_ME_WHEN: 'Изпратете ми имейл когато:',
	SOMEONE_COMMENTS_ON_MY_ITEMS: 'Някой коментира едно от моите неща',
	SOMEONE_MENTIONS_ME: 'Някой ме споменава',
	SOMEONE_FOLLOWS_ME: 'Някой ме следва',
	SOMEONE_REPLIES_TO_MY_JOB_POSTING: 'Някой отговаря на моята обява за работа',


    CHANGE_YOUR_PLAN: 'Променете вашия план',
	UPGRADE_OR_DOWNGRADE_YOUR_CURRENT_PLAN: 'Надградете или понижете текущия си план.',
	CHANGING_PLAN_TAKES_EFFECT_IMMEDIATELY: 'Промяната на плана ще влезе в сила незабавно. Ще бъдете таксувани за останалата част от текущия месец.',
	PLAN_BASIC: 'Основен',
	PLAN_BASIC_DETAILS: 'Начален план за индивидуални потребители.',
	PLAN_TEAM: 'Екип',
	PLAN_TEAM_DETAILS: 'Сътрудничество до 10 души.',
	PLAN_ENTERPRISE: 'Предприятие',
	PLAN_ENTERPRISE_DETAILS: 'За по-големи предприятия.',
	PAYMENT_DETAILS: 'Детайли за плащане',
	UPDATE_BILLING_INFORMATION: 'Актуализирайте вашата информация за фактуриране. Уверете се, че сте настроили правилно местоположението си, тъй като това може да повлияе на данъчните ставки.',
	CARD_HOLDER: 'Титуляр на картата',
	CARD_NUMBER: 'Номер на картата',
	EXPIRATION_DATE: 'Дата на изтичане',
	CVC: 'CVC / CVC2',
	ZIP_CODE: 'Пощенски код',

    CHANGE_PASSWORD: 'Променете паролата си',
    // deepcode ignore NoHardcodedPasswords: These aren't passwords, they are just a label of fields
    PASSWORD_CHANGE_LIMIT: 'Можете да променяте паролата си само два пъти в рамките на 24 часа!',
    // deepcode ignore NoHardcodedPasswords: These aren't passwords, they are just a label of fields
    CURRENT_PASSWORD: 'Текуща парола',
	// deepcode ignore NoHardcodedPasswords: These aren't passwords, they are just a label of fields
    NEW_PASSWORD: 'Нова парола',
    SECURITY_PREFERENCES: 'Настройки за сигурност',
    SECURITY_PREFERENCES_DESC: 'Запазете акаунта си по-сигурен със следните предпочитания.',
    ENABLE_2STEP_AUTH: 'Активиране на двустепенно удостоверяване',
	// deepcode ignore NoHardcodedPasswords: These aren't passwords, they are just a label of fields
    TWO_STEP_AUTH_DESC: 'Защитава ви срещу кражба на парола, като изисква код за удостоверяване чрез SMS при всяко влизане.',
	// deepcode ignore NoHardcodedPasswords: These aren't passwords, they are just a label of fields
    ASK_PASSWORD_CHANGE: 'Искай промяна на паролата на всеки 6 месеца',
	// deepcode ignore NoHardcodedPasswords: These aren't passwords, they are just a label of fields
    PASSWORD_CHANGE_DESC: 'Прост, но ефективен начин за защита срещу изтичане на данни и кражба на пароли.',

    ADD_TEAM_MEMBER: 'Добавяне на член на екипа',
    ENTER_EMAIL: 'Въведете имейл',

    SETTINGS: 'Настройки',
    ACCOUNT: 'Акаунт',
    ACCOUNT_SUBTITLE: 'Управлявайте своя публичен профил и лична информация',
    SECURITY_SUBTITLE: 'Управлявайте предпочитанията си за парола и двустепенно удостоверяване',
    PLAN_BILLING: 'План и плащане',
    PLAN_BILLING_SUBTITLE: 'Управлявайте своя абонаментен план, начин на плащане и информация за фактуриране',
    NOTIFICATIONS: 'Известия',
    NOTIFICATIONS_SUBTITLE: 'Управлявайте кога и по кои канали ще получавате известия',
    TEAM: 'Екип',
    TEAM_SUBTITLE: 'Управлявайте съществуващия си екип и добавяйте нови членове',
    HOTEL: 'Хотелски настройки',
    HOTEL_SUBTITLE: 'Тук може да управлявате вашия хотел',

    USERS: 'Потребители',
    HOTEL_TEXT: 'Използвайте тази страница, за да управлявате потребителите в DEMO HOTEL.',
    INVITE_USER: '+ Поканете потребител',
    INVITE: 'Покани',
    STATUS: 'Статус',
    Search_by_email: 'Търсете по имейл',
    Enter_email: 'Въведете имейл',
    ACTIONS: 'Действия',
    ACTIVE: 'Активен',
    INACTIVE: 'Неактивен',
	ACTIVE_ITEM: 'Активен елемент',
	INACTIVE_ITEM: 'Неактивен елемент',
    
    // Roles
    ADMIN: 'Администратор',
    RECEPTION: 'Рецепция',
    MAIN_CLEANER: 'Главен камериер',
    CLEANER: 'Камериер',
    TECH_SUPPORT: 'Техническа поддръжка',
    GODFATHER: 'GODFATHER',
    
    // Success Messages
    USER_INVITED_SUCCESS: 'Потребителят е поканен успешно',
    USER_DISABLED_SUCCESS: 'Потребителят е деактивиран успешно',
    USER_ENABLED_SUCCESS: 'Потребителят е активиран успешно',
    
    // Error Messages
    FAILED_TO_FETCH_USERS: 'Неуспешно зареждане на потребители',
    FAILED_TO_INVITE_USER: 'Неуспешно поканване на потребител',
    FAILED_TO_CHANGE_USER_ROLE: 'Неуспешна промяна на ролята на потребителя',
    FAILED_TO_DISABLE_USER: 'Неуспешно деактивиране на потребител. Моля опитайте отново',
    FAILED_TO_ENABLE_USER: 'Неуспешно активиране на потребител. Моля опитайте отново',
    
    // Pagination
    SHOWING: 'Показване на',
    OF: 'от',
    PAGE: 'Страница',

    EDIT_ROOM: 'Редактиране на стая',
    CREATE_ROOM: 'Създаване на стая',
    ROOM_MANAGEMENT: ' Управление на стаи',
    ROOM: 'Име',
    BEDS: 'Брой легла',
    FLOOR: 'Етаж',
    SELECT_FLOOR: 'Изберете етаж',
    CONFIRM_EDIT: 'Промени стаята',
    CONFIRM_CREATE: 'Създаване на стая',

    // Floor management
	FLOOR_NAME: 'Име на етаж',
	FLOOR_NUMBER: 'Номер на етаж',
	CREATE_FLOOR: 'Създаване на етаж',
	EDIT_FLOOR: 'Редактиране на етаж',
	CONFIRM_CREATE_FLOOR: 'Създаване на етаж',
	CONFIRM_EDIT_FLOOR: 'Промяна на етаж',
	FLOOR_MANAGEMENT: 'Управление на етажи',
	
	// Tabs
	FLOORS_TAB: 'Етажи',
	ROOMS_TAB: 'Стаи',
	CHECKLISTS_TAB: 'Списъци за почистване',

	// Room Types
	ROOM_TYPE: 'Тип стая',
	SELECT_ROOM_TYPE: 'Изберете тип стая',
	SINGLE_ROOM: 'Единична стая',
	DOUBLE_ROOM: 'Двойна стая',
	TWIN_ROOM: 'Стая с две единични легла',
	TRIPLE_ROOM: 'Тройна стая',
	QUEEN_ROOM: 'Стая с голямо легло',
	KING_ROOM: 'Стая с кралско легло',
	STUDIO_ROOM: 'Студио',
	SUITE: 'Апартамент',
	JUNIOR_SUITE: 'Малък апартамент',
	PRESIDENTIAL_SUITE: 'Президентски апартамент',

	// Checklist management
	CHECKLIST_MANAGEMENT: 'Управление на списъци за почистване',
	CHECKLIST_MANAGEMENT_DESC: 'Създайте и управлявайте списъци за почистване, които ще се използват от почистващият персонал по време на почистването на стаите.',
	CHECKLIST_FEATURE_COMING_SOON: 'Функцията за управление на списъци за почистване ще бъде достъпна тук скоро.',
	
	// Checklist CRUD operations
	CREATE_CHECKLIST: 'Създаване на списък',
	EDIT_CHECKLIST: 'Редактиране на списък',
	UPDATE_CHECKLIST: 'Обновяване на списък',
	DELETE_CHECKLIST: 'Изтрий списък',
	
	// Checklist properties
	CHECKLIST_NAME: 'Име на списъка',
	DEFAULT: 'По подразбиране',
	SET_AS_DEFAULT_CHECKLIST: 'Задай като списък по подразбиране',
	BASIC_INFORMATION: 'Основна информация',
	CHECKLIST_ASSIGN_TO_ROOM_TYPE: 'Присвои към тип стая',
	CHECKLIST_ROOM_TYPE_DESC: 'Изберете тип стая, за да присвоите този списък само към този тип стаи. Оставете празно за използване като общ списък.',
	
	// Maintenance Items
	MAINTENANCE_ITEMS_TAB: 'Поддръжка',
	MAINTENANCE_ITEMS_MANAGEMENT: 'Управление на елементи за поддръжка',
	MAINTENANCE_ITEMS_MANAGEMENT_DESC: 'Управлявайте елементи за поддръжка с многоезична поддръжка. Тези елементи се използват при създаването на заявки за поддръжка.',
	MAINTENANCE_ITEMS_ACCESS_DENIED: 'Достъпът е отказан. Само потребители с роли Godfather и Admin могат да управляват елементи за поддръжка.',
	CREATE_MAINTENANCE_ITEM: 'Създай елемент за поддръжка',
	EDIT_MAINTENANCE_ITEM: 'Редактирай елемент за поддръжка',
	DELETE_MAINTENANCE_ITEM: 'Изтрий елемент за поддръжка',
	DELETE_MAINTENANCE_ITEM_CONFIRM: 'Сигурни ли сте, че искате да изтриете елемента за поддръжка "{{name}}"? Това действие не може да бъде отменено.',
	SEARCH_MAINTENANCE_ITEMS: 'Търси елементи за поддръжка...',
	ALL_CATEGORIES: 'Всички категории',
	NO_MATCHING_ITEMS: 'Няма намерени съвпадащи елементи',
	NO_MAINTENANCE_ITEMS_FOUND: 'Няма намерени елементи за поддръжка',
	CREATE_FIRST_MAINTENANCE_ITEM: 'Създайте вашия първи елемент за поддръжка, за да започнете.',
	MAINTENANCE_ITEM_CREATED: 'Елементът за поддръжка е създаден успешно',
	MAINTENANCE_ITEM_UPDATED: 'Елементът за поддръжка е обновен успешно',
	MAINTENANCE_ITEM_DELETED: 'Елементът за поддръжка е изтрит успешно',
	FAILED_TO_FETCH_MAINTENANCE_ITEMS: 'Неуспешно зареждане на елементи за поддръжка',
	FAILED_TO_SAVE_MAINTENANCE_ITEM: 'Неуспешно запазване на елемент за поддръжка',
	FAILED_TO_DELETE_MAINTENANCE_ITEM: 'Неуспешно изтриване на елемент за поддръжка',
	MAINTENANCE_ITEM_NAME_REQUIRED: 'Поне един превод на името е задължителен',
	MAINTENANCE_ITEM_CATEGORY_REQUIRED: 'Категорията е задължителна',
	MAINTENANCE_ITEM_TRANSLATIONS_DESC: 'Предоставете преводи за всеки поддържан език. Поне един превод е задължителен.',
	ITEM_NAME: 'Име на елемента',
	REPLACEMENT_COST: 'Цена на подмяна',
	SORT_ORDER: 'Ред на сортиране',
	TRANSLATIONS: 'Преводи',
	FURNITURE: 'Мебели',
	ELECTRONICS: 'Електроника',
	BATHROOM: 'Баня',
	LIGHTING: 'Осветление',
	OTHER: 'Други',
	
	// Checklist items
	CHECKLIST_ITEMS: 'Задачи на списъка',
	ADD_NEW_ITEM: 'Добави нова задача',
	EDIT_ITEM: 'Редактирай задача',
	ITEM_TITLE: 'Заглавие на задачата',
	CATEGORY: 'Категория',
	ESTIMATED_MINUTES: 'Прогнозни минути',
	REQUIRED_ITEM: 'Задължителна задача',
	ADD_ITEM: 'Добави задача',
	CURRENT_ITEMS: 'Текущи задачи',
	
	// Checklist category options
	CHECKLIST_BEDROOM: 'Спалня',
	CHECKLIST_BATHROOM: 'Баня',
	CHECKLIST_BOTH: 'И двете',
	CHECKLIST_GENERAL: 'Общи',
	SELECT_CHECKLIST_CATEGORY: 'Избери категория',
	
	// Checklist display
	ITEMS_COUNT: 'Брой задачи: {{count}}',
	PREVIEW_ITEMS: 'Преглед на задачи',
	MORE_ITEMS: 'още задачи',
	NO_CHECKLISTS_FOUND: 'Няма намерени списъци',
	CREATE_FIRST_CHECKLIST: 'Създайте вашия първи списък за почистване, за да започнете.',
	UPDATE_ITEM: 'Обнови задача',
	NO_FLOORS_FOUND: 'Няма намерени етажи',
	NO_ROOMS_FOUND: 'Няма намерени стаи',
	
	// Checklist visibility settings
	SHOW_CHECKLIST_TO_CLEANERS: 'Покажи списъка на камериерите по време на почистване',
	CHECKLIST_VISIBILITY_WARNING: 'Ако е изключено, камериерите няма да могат да проверяват кои елементи са завършили и възможността за отметка/премахване на отметка на елементи сега е активирана само за Главните камериери.',
	CHECKLIST_VISIBILITY_SETTINGS: 'Настройки за видимост на списъка',
	SETTINGS_UPDATED_SUCCESS: 'Настройките са обновени успешно',
	SETTINGS_UPDATE_ERROR: 'Неуспешно обновяване на настройките. Моля опитайте отново.',

	// Room creation/update error messages
	ROOM_NUMBER_EXISTS_ERROR: 'Стаята с този номер вече съществува',
	FLOOR_NOT_FOUND_ERROR: 'Избраният етаж не е намерен',
	ROOM_CREATION_ERROR: 'Неуспешно създаване на стая. Моля опитайте отново.',
	ROOM_NOT_FOUND_ERROR: 'Стаята не е намерена',
	ROOM_UPDATE_ERROR: 'Неуспешно обновяване на стая. Моля опитайте отново.',
	ROOM_CREATION_SUCCESS: 'Стаята е създадена успешно',
	ROOM_UPDATE_SUCCESS: 'Стаята е обновена успешно',
	ROOM_DELETION_SUCCESS: 'Стаята е изтрита успешно',
	ROOM_DELETION_ERROR: 'Неуспешно изтриване на стая. Моля опитайте отново.',
	ROOM_DELETE_CONFIRM_TITLE: 'Потвърждение за изтриване на стая',
	ROOM_DELETE_CONFIRM_BODY: 'Сигурни ли сте, че искате да изтриете тази стая? Това действие не може да бъде отменено.',
	CONFIRM: 'Потвърди',
	PROCESSING: 'Премахване...',
	

    INVALID_EMAIL: 'Невалиден имейл',
    
    // RoomieAI
    CREATED_DATE: 'Дата на създаване',

 // Main Cleaner Room Access Management
 MANAGE_ROOMS: 'Управление на стаи',
 MANAGE_ROOMS_DIALOG_TITLE: 'Управление на достъпа до стаи за {{cleanerName}}',
 MANAGE_ROOMS_DIALOG_SUBTITLE: 'Изберете кои стаи този Главен камериер може да вижда и достъпва',
 MANAGE_ROOMS_SEARCH_PLACEHOLDER: 'Търси стаи...',
 SELECT_ALL: 'Избери всички',
 DESELECT_ALL: 'Премахни всички',
 SELECTED_ROOMS_COUNT_one: '{{count}} избрана стая',
 SELECTED_ROOMS_COUNT_other: '{{count}} избрани стаи',
 FLOOR_ROOMS_COUNT_one: '{{count}} стая',
 FLOOR_ROOMS_COUNT_other: '{{count}} стаи',
 NO_ROOMS_AVAILABLE: 'Няма налични стаи',
 ROOMS_ASSIGNED_SUCCESS: 'Стаите са назначени успешно',
 ROOMS_ASSIGNMENT_FAILED: 'Неуспешно назначаване на стаи. Моля опитайте отново.',
 LOADING_ROOMS: 'Зареждане на стаи...',
 NO_USERS_FOUND: 'Няма намерени потребители',
 DISABLE_USER_TOOLTIP: 'Деактивирай достъпа на потребителя',
 ENABLE_USER_TOOLTIP: 'Активирай достъпа на потребителя',

};

export default locale;
